import { Link } from "react-router-dom";
import "./SeminaryCardStyles.scss";
import { SeminaryData } from "../../../../../interfaces/Vocabulary/VocabularyInterfaces";

interface SeminaryCardProps {
	data: SeminaryData;
}

function SeminaryCard({ data }: SeminaryCardProps) {
	return (
		<div className="vocabulary-seminary-card">
			<div className="title">
				<h2>Seminario {data.seminary}</h2>
				<h3>{data.totalWords} términos</h3>
			</div>
			<div className="bookmarks" style={!(data.bookmarks ? data.bookmarks > 0 : false) ? { display: "none" } : {}}>
				{data.bookmarks}
			</div>
			<div className="action">
				<Link to={`/admin/vocabulario/seminario/${data.seminary}`}>
					<button>editar</button>
				</Link>
			</div>
		</div>
	);
}

export default SeminaryCard;
